import React from 'react';
import styled from 'styled-components/macro';
import cx from 'classnames';
import { useSelector } from 'src/client/redux';
import { TABLET_PORTRAIT } from 'src/client/constants/mediaQueries';
import { useJoinUrl } from 'src/client/components/buttons/JoinButton';
import { useShowSfwSite } from 'src/client/helpers/useFeatureFlags';
import { AD_ZONE_BANNER } from 'src/client/constants/joinCampaigns';
import { usePromotions } from 'src/client/helpers/usePromotions';

type ImageLinkProps = {
  bannerDesktop: string;
  bannerMobile: string;
};

const ImageLink = styled.a<ImageLinkProps>`
  aspect-ratio: 1240/1136;
  background-image: url(${(props) => props.bannerMobile});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  display: block;
  margin: auto;
  max-width: 1240px;
  width: 100%;

  @media ${TABLET_PORTRAIT} {
    background-image: url(${(props) => props.bannerDesktop});
    aspect-ratio: 1170/658;
    max-width: 1170px;

    &.hero-slider {
      aspect-ratio: 2162/960;
      max-width: 2162px;
    }
  }
`;

export const PromoBanner = () => {
  const { splash } = useSelector((state) => state.app.config);
  const site = useSelector((state) => state.site);
  const [joinHref] = useJoinUrl({ campaign: AD_ZONE_BANNER });
  const showSfwSite = useShowSfwSite();
  const { getPromoImage } = usePromotions();

  const sliderType = splash?.components?.sliderComponent?.component ?? '';

  const showHeroSlider = ['HeroSlider', 'StraplezSlider'].includes(sliderType);

  const abbreviation = site.abbreviation.toUpperCase();
  const nonNudeText = showSfwSite ? '_nonnude' : '';
  const bannerDesktop = getPromoImage(['banners', abbreviation, `banner${nonNudeText}.jpg`]);
  const bannerMobile = getPromoImage(['banners', abbreviation, `banner_phone${nonNudeText}.jpg`]);

  return (
    <ImageLink
      bannerDesktop={bannerDesktop}
      bannerMobile={bannerMobile}
      className={cx({ 'hero-slider': showHeroSlider })}
      href={joinHref}
    />
  );
};
